module.exports = __webpack_public_path__ + "img/marker.2b06f71d.svg";